import { userClient } from "@/api/grpc";
import { useAuthedRpc } from "@/hooks/common";
import { create } from "@bufbuild/protobuf";
import { UserSchema } from "@generated/proto/model";
import { CreateUserRequestSchema } from "@generated/proto/service";

/**
 * Hook for UserService.CreateUser
 */
export function useCreateUser() {
  const { run, loading, error } = useAuthedRpc(
    async (
      user,
      input: Partial<Pick<import("@generated/proto/model").User, "displayName" | "email">>
    ) => {
      const request = create(CreateUserRequestSchema, {
        user: create(UserSchema, {
          userId: user.uid,
          displayName: input.displayName ?? "",
          email: input.email ?? "",
        } as any),
      });

      const response = await userClient.createUser(request as any);
      return response;
    }
  );

  return { createUser: run, loading, error };
}


